/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import { PAGE_SIZE_OPTIONS } from '@/constaint';
import { useQueryString } from '@/hooks';
import { Meta } from '@/types/api/common';
import CustomSelect from '../CustomSelect';
import PaginationCustom from '../PaginationCustom';

const PaginationWithPageSize = ({
  size,
  meta,
  onChangePage,
  onChangePageSize,
  isCustomPageSize = true,
}: {
  size: 'md' | 'lg' | 'sm';
  meta: Meta;
  onChangePage?: (page: number) => void;
  onChangePageSize?: (pageSize: number) => void;
  isCustomPageSize?: boolean;
}) => {
  const { queryString, setQueryString } = useQueryString();

  const handlePageChange = (page: number) => {
    if (onChangePage) {
      onChangePage(page);
    } else {
      setQueryString({ ...queryString, page });
    }
  };

  const handlePageSizeChange = (pageSize: string) => {
    if (onChangePageSize) {
      onChangePageSize(Number(pageSize));
    } else {
      setQueryString({ ...queryString, pageSize });
    }
  };

  return (
    <div className='p-[12px_24px_16px_24px] lg:flex items-center lg:justify-between flex-wrap gap-4'>
      {isCustomPageSize && (
        <div
          className={`flex items-center gap-2 w-max my-2 lg:my-0 ${size === 'sm' ? 'text-sm' : ''}`}
        >
          <div>Showing</div>
          <CustomSelect
            selectedKeys={[meta?.pageSize?.toString() || '10']}
            options={PAGE_SIZE_OPTIONS}
            onSelectItem={(item) => handlePageSizeChange(item.value)}
          />
          <div>of {meta?.total || 1} results</div>
        </div>
      )}
      <PaginationCustom
        total={meta?.totalPages || 1}
        page={meta?.page || 1}
        onChangePage={handlePageChange}
        size={size}
      />
    </div>
  );
};

export default PaginationWithPageSize;
